module.exports = __webpack_public_path__ + "media/images/sidebar-3-55a1989fbb6eb9ceb5fc33b98a566745.jpg";